import React from "react";

export const LazyDepositDocument = React.lazy(() =>
  import("../scenes/OrderPayment/DepositDocument/index")
);

export const LazyOrderPaymentFinancial = React.lazy(() =>
    import("../scenes/OrderPayment/Financial/OrderPaymentFinancial")
  );

  export const LazyOrderPaymentArchive = React.lazy(() =>
    import("../scenes/OrderPayment/Archive/Archive")
  );